import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/img/offertesoci.png'


const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_3 = { class: "mt-3 midTitle" }
const _hoisted_4 = { class: "horizontalContainer mt-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "categoryImage" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "mt-3 midTitle" }
const _hoisted_10 = { class: "fullTextOfferContainer mt-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "subTitle" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 offerteSociBanner" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_18 = { class: "mt-3 midTitle" }
const _hoisted_19 = { class: "horizontalContainer mt-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "categoryImage" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "mt-3 midTitle" }
const _hoisted_25 = { class: "horizontalContainer mt-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "offerImage" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "text" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "subTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_lens = _resolveComponent("icon-lens")!
  const _component_input_with_icon = _resolveComponent("input-with-icon")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_input_with_icon, {
      modelValue: _ctx.searchText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_icon_lens)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.fullTextResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.fullTextResponse = null; _ctx.searchText = ''})
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Indietro",
              text: "Indietro"
            })
          ]),
          (_ctx.fullTextResponse.categories.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Categorie trovate",
                    text: "Categorie trovate"
                  })
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fullTextResponse.categories, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "horizontalSpacer",
                      key: item.identifier
                    }, [
                      _createElementVNode("div", {
                        class: "categoryBubble",
                        onClick: ($event: any) => (_ctx.navTo('/network/shop/' + item.identifier))
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("img", {
                            src: item.image.publicUrl
                          }, null, 8, _hoisted_7)
                        ]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_5)
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.fullTextResponse.offers.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Offerte trovate",
                    text: "Offerte trovate"
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fullTextResponse.offers, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fullTextOfferSpacer",
                      key: item.identifier
                    }, [
                      _createElementVNode("div", {
                        class: "fullTextOffer",
                        onClick: ($event: any) => (_ctx.navTo('/network/shop/singleOffer/' + item.identifier))
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("img", {
                            src: item.image.publicUrl
                          }, null, 8, _hoisted_13)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.title.values[_ctx.$store.state.selectedLanguage]), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.subTitle.values[_ctx.$store.state.selectedLanguage]), 1)
                        ])
                      ], 8, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_localized_text, {
              localizedKey: "Categoria",
              text: "Categoria"
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "horizontalSpacer",
                key: item.identifier
              }, [
                _createElementVNode("div", {
                  class: "categoryBubble",
                  onClick: ($event: any) => (_ctx.navTo('/network/shop/' + item.identifier))
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("img", {
                      src: item.image.publicUrl
                    }, null, 8, _hoisted_22)
                  ]),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1)
                ], 8, _hoisted_20)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_localized_text, {
              localizedKey: "Popolari",
              text: "Popolari"
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularOffers, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "horizontalSpacer",
                key: item.identifier
              }, [
                _createElementVNode("div", {
                  class: "popularOffer",
                  onClick: ($event: any) => (_ctx.navTo('/network/shop/singleOffer/' + item.identifier))
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      src: item.image.publicUrl
                    }, null, 8, _hoisted_28)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(item.title.values[_ctx.$store.state.selectedLanguage]), 1),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.subTitle.values[_ctx.$store.state.selectedLanguage]), 1)
                  ])
                ], 8, _hoisted_26)
              ]))
            }), 128))
          ])
        ], 64))
  ]))
}